import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {setIsEmbeddedWithKiwi} from 'modules/common/actions/runtime'

import {useIsEmbeddedWithBrand} from '@vio/core/src/_web/brand/hooks/useIsEmbeddedWithBrand'

/**
 * Resolves the embedding context once and puts it in the store, so selectors
 * don't have to read `window.self !== window.top` themselves.
 */
export const useSyncStoreWithIsEmbedded = () => {
  const isEmbeddedWithKiwi = useIsEmbeddedWithBrand()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setIsEmbeddedWithKiwi(isEmbeddedWithKiwi))
  }, [dispatch, isEmbeddedWithKiwi])
}
